import React, { useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { TextField, FormControl, IconButton } from '@mui/material';
import Card from 'react-bootstrap/Card';
import "./Profile.css";
import { axiosPrivate } from '../../../api/axios';
import { toast } from "react-toastify";
import { ErrorMessage } from "@hookform/error-message";
import { Alert, Modal, Button, InputGroup } from "react-bootstrap";
import AuthContext from '../../../context/user-auth/AuthProvider';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Visibility, VisibilityOff } from "@mui/icons-material";




const Profile = (props) => {
  const {  userDetails, getUserDetails,updateMfaAuthentication } = useContext(AuthContext);
  const [mfa, setMfa] = useState(  userDetails?.is_mfa_enable_email);
  const [tabValue, setTabValue] = useState("first");
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showReSetPassword, setShowReSetPassword] = React.useState(false);

  const handleClickShowOldPassword = () => setShowOldPassword((show) => !show);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowReSetPassword = () => setShowReSetPassword((show) => !show);

  const {
    register: register1,
    watch,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm({
    defaultValue:{
      "first_name":  userDetails?.first_name,
      "last_name":  userDetails?.last_name
    }
  });
  const handleTab = (key) => {
    setTabValue(key);
    reset1();
  }

  const handleMFA = (e) => {
    if (mfa === true) {
      setMfa(false);
    }
    else {
      setMfa(true);
    }
  }

  const handleReset = async () => {

      reset1();
      props.onhide();

  }

  const profileAPI = async (data) => {
    let url1;
    let profilePayload;
   

    switch (tabValue) {
      case "first": {
        url1 = "/user/update";
        profilePayload = { firstName: data?.first_name, lastName: data?.last_name };
        try {
          await axiosPrivate.post(url1, profilePayload)
            .then((data) => {
              toast.success(data.data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
               getUserDetails();
             
              setTimeout(function () {
               props.onhide();
              }, 3000);

            })
            .catch((error) => {
              const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
              toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
            })
        }
        catch (error) {

        }
      }
        break;
      case "second": {
        url1 = "/user/change-password"; profilePayload = { oldPassword: data?.old_password, password: data?.new_password };
        try {
          await axiosPrivate.post(url1, profilePayload)
            .then((data) => {

              toast.success(data.data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
              data.data.success===true && 
               setTimeout(function () {
                props.onhide();
                props.logout();


               }, 3000);

            })
            .catch((error) => {
              const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
              toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
            })
        }
        catch (error) {

        }
      }
        break;
      case "third": {
        profilePayload = { isEmailMfaEnable: mfa };  updateMfaAuthentication(profilePayload);
        handleReset()
      }
        break;
    
    }

  }


  return (
    <>
      <Modal size='lg' show={ props.show} onHide={() => handleReset()} backdrop="static" keyboard={false} >
        <form onSubmit={handleSubmit1(profileAPI)}>
          <Modal.Header closeButton >
            <Modal.Title className='titles'>Update Profile</Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <Tab.Container id="left-tabs-example" defaultActiveKey="first" onSelect={(key) => handleTab(key)}>
              <Row>
                <Col sm={4}>
                  <Nav variant="pills" className="flex-column"  >
                    <Nav.Item>
                      <Nav.Link eventKey="first">Change Name</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Change Password</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Multi-Factor Authentication</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col sm={8}>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Card>
                        <Card.Body>

                          <FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small" >
                            <TextField id="first_name" name="first_name" defaultValue={  userDetails?.first_name || ""} placeholder="Enter First Name" label="First Name" {...register1("first_name", tabValue === "first" && {
                              required: "This field is required",
                            })}
                              aria-invalid={errors1.first_name ? true : false} sx={{
                                ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": { height: "0.6em" },
                                ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": { top: -5 }, '.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root': {
                                  padding: "10px 10px"
                                }
                              }} />
                            <ErrorMessage
                              errors={errors1}
                              name="first_name"
                              render={({ message }) => (
                                <Alert variant="danger" className="p-1 mb-0">
                                  {message}
                                </Alert>
                              )}
                            />
                          </FormControl>
                          <FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small">
                            <TextField id="last_name" name="last_name" defaultValue={  userDetails?.last_name || ""} placeholder="Enter Last Name" label="Last Name" {...register1("last_name")} sx={{
                              ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": { height: "0.6em" },
                              ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": { top: -5 }, '.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root': {
                                padding: "10px 10px"
                              }
                            }} />
                          </FormControl>

                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Card>
                        <Card.Body >
                          <InputGroup>
                            <FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small">
                              <TextField id="old_password" name="old_password" type={showOldPassword ? "text" : "password"} placeholder="Enter Old Password Here" label="Old Password" {...register1("old_password", tabValue === "second" && {
                                required: "This field is required",
                              })} aria-invalid={errors1.old_password ? true : false} />
                              <IconButton aria-label="toggle password visibility" className="position-absolute" tabIndex={-1} onClick={handleClickShowOldPassword} edge="end">
                                {showOldPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                              <ErrorMessage
                                errors={errors1}
                                name="old_password"
                                render={({ message }) => (
                                  <Alert variant="danger" className="p-1 mb-0">
                                    {message}
                                  </Alert>
                                )}
                              />
                            </FormControl>
                          </InputGroup>
                          
                          <InputGroup>
                            <FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small">
                              <TextField id="new_password" name="new_password" type={showPassword ? "text" : "password"} placeholder="Enter New Password Here" label="New Password"{...register1("new_password")}  />
                              <IconButton aria-label="toggle password visibility" className="position-absolute" tabIndex={-1} onClick={handleClickShowPassword} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </FormControl>
                          </InputGroup>
                          <InputGroup>
                            <FormControl sx={{ m: 1, minWidth: "100%", margin: "10px 0 10px" }} size="small">
                              <TextField id="confirm_new_password" name="confirm_new_password" type={showReSetPassword ? "text" : "password"} placeholder="Re-Enter New Password Here" label="Confirm New Password"{...register1("confirm_new_password", tabValue === "second" && {
                                required: "This field is required",
                                validate: (value) => value === watch("new_password") || "The password do not match",
                              })} aria-invalid={errors1.confirm_new_password ? true : false}
                               />
                              <IconButton aria-label="toggle password visibility" className="position-absolute" tabIndex={-1} onClick={handleClickShowReSetPassword} edge="end">
                                {showReSetPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                              <ErrorMessage
                                errors={errors1}
                                name="confirm_new_password"
                                render={({ message }) => (
                                  <Alert variant="danger" className="p-1 mb-0">
                                    {message}
                                  </Alert>
                                )}
                              />
                            </FormControl>
                          </InputGroup>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <Card className='mfa'>
                        <Card.Body>
                        <FormControl component="fieldset">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    id="custom-switch"
                                    defaultChecked={
                                      mfa || userDetails?.is_mfa_enable_email
                                    }
                                    onChange={handleMFA}
                                  />
                                }
                                label="Multi-Factor Authentication"
                              />
                            </FormGroup>
                          </FormControl>
                          {/* <Form>
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              label="Multi-Factor Authentication"
                              defaultChecked={mfa ||   userDetails?.is_mfa_enable_email}
                              onChange={handleMFA}
                            />
                          </Form> */}
                        </Card.Body>


                      </Card>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" className="btn btn-primary btnc" type='submit'>
              Save
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}

export default Profile